<template>
  <a-tooltip
    slot="after"
    placement="right"
    overlay-class-name="outside-config-tooltip"
  >
    <template slot="title">
      {{ text }}
    </template>
    <i class="iconfont iconicon-test31 tooltip-btn" />
  </a-tooltip>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss">
.outside-config-tooltip {
  .ant-tooltip-inner {
    color: $gray3;
  }
  .ant-tooltip-content:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 1px;
    top: 50%;
    margin-top: -7px;
    border-width: 7px 8px 7px 0;
    border-color: transparent;
    border-right-color: #ebebeb;
    border-style: solid;
  }
  .ant-tooltip-arrow {
    left: 4px !important;
    z-index: 2;
    border-right-color: #fff !important;
  }
}
</style>
